export const DEFAULT_CURRENCY_SYMBOL = 'Rs';

const CURRENCY_SYMBOL_STORAGE_KEY = 'sf_currency_symbol';

export function getCurrencySymbol(): string {
  if (typeof window === 'undefined') return DEFAULT_CURRENCY_SYMBOL;

  try {
    return localStorage.getItem(CURRENCY_SYMBOL_STORAGE_KEY) || DEFAULT_CURRENCY_SYMBOL;
  } catch {
    return DEFAULT_CURRENCY_SYMBOL;
  }
}

export function setCurrencySymbol(symbol: string) {
  // Normalize and fall back to default to avoid storing empty values.
  const normalized = (symbol ?? '').toString().trim();
  const value = normalized.length > 0 ? normalized : DEFAULT_CURRENCY_SYMBOL;

  if (typeof window === 'undefined') return;

  try {
    localStorage.setItem(CURRENCY_SYMBOL_STORAGE_KEY, value);
  } catch {
    // Ignore quota/security errors; callers should still render with defaults.
  }
}

export type FormatMoneyOptions = {
  decimals?: number;
};

export function formatMoney(
  value: number | string | null | undefined,
  options: FormatMoneyOptions = {}
) {
  const currencySymbol = getCurrencySymbol();
  const decimals = options.decimals ?? 2;
  const n = typeof value === 'string' ? Number(value) : (value ?? 0);

  if (!Number.isFinite(n)) return `${currencySymbol} —`;

  return `${currencySymbol} ${n.toFixed(decimals)}`;
}

